import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { HiOutlineCode } from "react-icons/hi";
import { PageTopBreadcrumb } from "../PageTopBreadcrumb";
import { colors, fontFamilyMono, radius } from "../../data/tokens";

const API_PATH = process.env.REACT_APP_API_PATH;

// Documentação técnica da API (Swagger), servida pelo próprio backend.
// Desde 16/10/2026 o servidor só a publica no ambiente de desenvolvimento:
// em produção ela abria sem login para qualquer pessoa — o login do painel
// protegia só esta moldura, não o endereço da API (TODO.md, item 28).
// A tela confere se a documentação responde: se sim (ambiente local),
// embute como antes; se não, explica onde encontrá-la.
export function ApiPage(props: any) {
  const [available, setAvailable] = useState<boolean | null>(null);

  useEffect(() => {
    let active = true;
    fetch(`${API_PATH}/api-json`, { method: "HEAD" })
      .then((response) => active && setAvailable(response.ok))
      .catch(() => active && setAvailable(false));
    return () => {
      active = false;
    };
  }, []);

  if (available === null) return null;

  if (available) {
    return (
      // Full-bleed: a margem negativa anula o padding global do #main-content
      // apenas nesta tela, e a altura desconta a barra superior fixa
      <iframe
        src={API_PATH + "/api"}
        title="API"
        style={{
          display: "block",
          border: "none",
          overflow: "hidden",
          width: "calc(100% + var(--content-padding-x) * 2)",
          height: "calc(100vh - 48px)",
          margin:
            "calc(var(--content-padding-y) * -1) calc(var(--content-padding-x) * -1)",
        }}
      />
    );
  }

  return (
    <>
      <PageTopBreadcrumb title="Para o desenvolvedor" firstPath="/#/api" />
      <Card sx={{ marginBottom: 3 }}>
        {/* Box em vez de CardContent: o App.css zera o padding de todo
            .MuiCardContent-root com !important */}
        <Box
          sx={{
            padding: { xs: 2.5, md: 4 },
            display: "flex",
            gap: 2,
            alignItems: "flex-start",
          }}
        >
          <Box sx={{ color: colors.primary, flexShrink: 0, marginTop: 0.25 }}>
            <HiOutlineCode size={28} />
          </Box>
          <Box>
            <Typography
              sx={{ fontSize: 17, fontWeight: 700, color: colors.primaryDark }}
            >
              Documentação técnica da API
            </Typography>
            <Typography
              sx={{ fontSize: 13.5, color: colors.textStrong, marginTop: 1 }}
            >
              Por segurança, a documentação não é publicada no servidor de
              produção: ela ficava aberta, sem login, para qualquer pessoa na
              internet.
            </Typography>
            <Typography
              sx={{ fontSize: 13.5, color: colors.textStrong, marginTop: 1 }}
            >
              Ela continua disponível no ambiente de desenvolvimento: com a API
              rodando localmente, abra esta mesma tela no painel local ou
              acesse direto{" "}
              <Box
                component="span"
                sx={{
                  fontFamily: fontFamilyMono,
                  fontSize: 12.5,
                  backgroundColor: colors.bgContent,
                  color: colors.primaryDark,
                  borderRadius: `${radius.sm}px`,
                  paddingX: 0.75,
                  paddingY: 0.25,
                }}
              >
                http://localhost:3000/api
              </Box>
              .
            </Typography>
          </Box>
        </Box>
      </Card>
    </>
  );
}
